/**
 * Derive what the user is currently looking at from the route path, so BEXI can
 * tailor help to the page (an assistant builder, the apps list, a 3D app, ...).
 * Pure string parsing — works wherever the dock is mounted.
 */
export function derivePageContext(pathname) {
    const path = pathname || '';
    const org = path.match(/organizations\/([^/]+)/);
    const sub = path.match(/\/sub\/([^/]+)/);
    const base = {
        url: path,
        oragID: org ? org[1] : undefined,
        subOragID: sub ? sub[1] : undefined,
        area: 'Platform',
        page: 'Unknown',
    };

    let m;
    if ((m = path.match(/de-studio\/unified-builder\/([^/?#]+)/))) {
        return {
            ...base,
            area: 'DE Studio',
            page: 'Assistant (Digital Employee) builder',
            assistantId: m[1]
        };
    }
    if (path.includes('/de-studio/unified-builder')) {
        return {
            ...base,
            area: 'DE Studio',
            page: 'Assistant builder (new / unsaved)'
        };
    }
    if (path.includes('/de-studio/library')) return {
        ...base,
        area: 'DE Studio',
        page: 'Library'
    };
    if (path.includes('/de-studio/channels')) return {
        ...base,
        area: 'DE Studio',
        page: 'Channels'
    };
    if (path.includes('/de-studio/activity')) return {
        ...base,
        area: 'DE Studio',
        page: 'Activity'
    };
    if (path.includes('/de-studio/usage')) return {
        ...base,
        area: 'DE Studio',
        page: 'Usage'
    };
    if (path.includes('/de-studio/knowledge')) return {
        ...base,
        area: 'DE Studio',
        page: 'Knowledge base'
    };
    if (path.includes('/de-studio')) return {
        ...base,
        area: 'DE Studio',
        page: 'DE Studio home'
    };

    if ((m = path.match(/3dapp-studio\/app\/([^/]+)\/([^/?#]+)/))) {
        return {
            ...base,
            area: '3D App Studio',
            page: `App — ${m[2]}`,
            appId: m[1]
        };
    }
    if ((m = path.match(/3dapp-studio\/app\/([^/?#]+)/))) {
        return {
            ...base,
            area: '3D App Studio',
            page: 'App',
            appId: m[1]
        };
    }
    if (path.includes('3dapp-studio')) return {
        ...base,
        area: '3D App Studio',
        page: 'Apps list'
    };

    return base;
}

/** One-line human summary for the system prompt. */
export function pageContextSummary(ctx) {
    if (!ctx) return '';
    const bits = [ctx.area, ctx.page].filter(Boolean).join(' · ');
    const id = ctx.assistantId ? ` (assistant ${ctx.assistantId})` : ctx.appId ? ` (app ${ctx.appId})` : '';
    return `${bits}${id}`;
}
